import { render, staticRenderFns } from "./campaigns.svg?vue&type=template&id=9cd31542"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports